module.exports = __webpack_public_path__ + "static/media/right2_hover.94349c41.svg";